import styles from './UploadButton.module.css';

const UploadButton = ({ id, onUpload, children }) => {
  return (
    <div className={styles.upload}>
      <label htmlFor={id} className={styles.label}>
        {children}
      </label>
      <input
        type="file"
        name={id}
        id={id}
        accept="image/png, image/jpeg, image/jpg"
        className={styles.input}
        onChange={onUpload}
      />
    </div>
  );
};

export default UploadButton;
